export function validatePlaca(placa?: string): boolean {
  if (!placa) return false;

  const regexPlacaBR = /^[A-Z]{3}[0-9][A-Z0-9][0-9]{2}$/i;

  return regexPlacaBR.test(placa.trim().toUpperCase());
}
